module.exports = __webpack_public_path__ + "5081f4bbb81465b72123769a491b7b87.png";